import { render, staticRenderFns } from "./SystemFunctionSelect.vue?vue&type=template&id=56d391a4&scoped=true&"
import script from "./SystemFunctionSelect.vue?vue&type=script&lang=js&"
export * from "./SystemFunctionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d391a4",
  null
  
)

export default component.exports